<template lang="pug">
header.main-header
  .menu
    .left
      router-link.mainlogo(to="/")
        img(src="@/assets/img/main-logo.svg")
      a.companylogo(href="https://www.ts-h.co.jp/", target="_blank")
        img(src="@/assets/img/ts-logo.svg")
    .right
      // blog
      a.item(href="./blog.php")
        .icon
          img(src="@/assets/img/icon/blog.svg")
        .text Blog
      // member
      .item.member
        .icon
          img(:src="iconUrl('member')" style="width:95%")
        .text member
      // campaign
      router-link.item.campaign(to="campaign")
        .icon
          img(:src="iconUrl('campaign')" style="width:76%")
        .text campaign
      // gallery
      a.item(href="https://renodeluxe.jp/gallery/")
        .icon
          img(src="@/assets/img/icon/gallery.svg")
        .text Gallery
      // staff
      router-link.item.staff(to="staff")
        .icon
          img(:src="iconUrl('staff')" style="width:78%")
        .text
          | company
          br 
          | staff
      // recruit
      router-link.item.recruit(to="recruit")
        .icon
          img(:src="iconUrl('recruit')" style="width:75%")
        .text recruit
      // contact
      a.item.contact(href="./contact.php")
        .icon
          img(:src="iconUrl('contact')", :style="{ width: '88%' }")
        .text contact
</template>
<script>
export default {
  data() {
    return {
      icon: [
        {
          img: 'member',
          text: 'member',
          width: 95,
          textwidth: 35,
        },
        {
          img: 'campaign',
          text: 'campaign',
          width: 76,
          textwidth: 41,
        },
        {
          img: 'staff',
          text: 'company<br>staff',
          width: 78,
          textwidth: 39,
        },
        {
          img: 'recruit',
          text: 'recruit',
          width: 75,
          textwidth: 28,
        },
        // {
        //     img: "contact",
        //     width: 88,
        //     textwidth: 31
        // }
      ],
    };
  },
  methods: {
    iconUrl(file) {
      return require('@/assets/img/icon/' + file + '.svg');
    },
    textUrl(file) {
      return require('@/assets/img/icon/' + file + '_text.svg');
    },
  },
};
</script>
<style lang="scss" scoped>
.main-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background: rgba(#fff, 0.6);
  > .menu {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: space-between;

    @media #{$pc} {
      width: 1020px;
      flex-direction: row;
      padding: 5px 16px;
    }

    > .left {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px;
      border-top: 2px solid #eceff1;
      width: 100%;

      @media #{$pc} {
        padding: 0;
        border: none;
        justify-content: flex-start;
      }

      img {
        width: 100%;
      }

      > .mainlogo {
        width: 91px;
        margin-right: 24px;
      }
      > .companylogo {
        width: 170px;
      }
    }

    > .right {
      display: flex;
      align-items: flex-start;
      padding: 8px;

      @media #{$pc} {
        padding: 0;
      }

      > .item {
        margin: 8px 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        text-decoration: none;
        @media #{$pc} {
          margin: 8px;
        }

        > .text {
          font-size: 10px;
          text-align: center;
          color: #333333;
          line-height: 1.1;
        }
      }

      > .item.member,
      > .item.campaign {
        display: none;
        @media #{$pc} {
          display: flex;
          margin: 8px;
        }
      }

      > .item > .icon {
        height: 32px;
        width: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 5px;
      }

      > .item > .text {
        width: 100%;
        @media (-ms-high-contrast: none) {
          height: 10px;
        }
      }

      > .item > .text.staff {
        padding-top: 1.8px;
        @media (-ms-high-contrast: none) {
          height: 20px;
        }
      }
    }
  }
}
</style>
